<template>
  <div class="login-page">
    <!-- <canvas id="canvas"></canvas> -->
    <div class="login-container">
      <div class="login-title">
        <div class="login-logo">
          <img :src="`./images/theme/${theme}/logoOig.png`" />
        </div>
        <div class="login-title-text">
          <h5>
            {{ $t("system.platform.name") }}
          </h5>
        </div>
      </div>
      <div class="form-container">
        <el-form ref="paramForm" class="login-form" :rules="paramRules" :model="paramForm"
          @keyup.enter.native="userLogin">
          <el-form-item label prop="userName">
            <div class="form-item">
              <span class="form-input-icon"><i class="iconfont icon-yonghuming"></i></span>
              <input v-model="paramForm.userName" class="form-input" v-bind:autofocus="true"
                :placeholder="$t('login.placeholder.username')" />
            </div>
          </el-form-item>
          <el-form-item label prop="password">
            <div class="form-item">
              <span class="form-input-icon"><i class="iconfont icon-password"></i></span>
              <input v-model="paramForm.password" type="password" class="form-input"
                :placeholder="$t('login.placeholder.password')" />
            </div>
          </el-form-item>
          <el-button type="primary" class="sign-button" :loading="loading" @click="userLogin">
            {{ $t("login.button.submit") }}
            <i class="cam icon-login"></i>
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@src/common/utils";
import sha256 from "js-sha256";
import animation from "./canvas";
import eventBus from "@src/common/utils/eventBus";
import eventConfig from "@src/common/config/eventConfig";
import cacheKeys from "@/common/config/cacheKeys";
export default {
  components: {},
  data() {
    return {
      theme: this.$store.getters.currentTheme,
      language: this.$store.getters.currentLanguage,
      langList: this.$i18n.LANGUAGES,
      loading: false,
      paramForm: {
        userName: "",
        password: "",
      },
      paramRules: {
        userName: [
          {
            required: true,
            message: this.$t("login.placeholder.username"),
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.placeholder.password"),
            trigger: ["blur", "change"],
          },
        ],
      },
      target: { path: this.$config.HOME_PAGE },
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  created() {
    sessionStorage.removeItem("isAuth");
  },
  mounted() {
    // animation.initCanvas().run();
    // window.onresize = function () {
    //   animation.refresh();
    // };
    this.initLocalConfig();
    // 获取跳转至登录页面的原始页面
    // if (this.$route.query) {
    //   let params = utils.parseQueryParams(this.$route.query);
    //   if (params && params.path && params.path.length) {
    //     this.target = params;
    //   }
    // }
    // 如果个人信息存在则免登录
    // if (this.userInfo) {
    //   this.$router.push(this.target);
    // }
  },
  beforeDestroy: function () {
    // window.onresize = null;
    // animation.stop();
  },
  methods: {
    initSystem() {
      this.$store.dispatch("GetSysOptions");
    },
    initLocalConfig() {
      this.$store.dispatch("GetSysConfig");
    },
    userLogin() {
      this.$refs["paramForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          let param = {
            name: encodeURI(this.paramForm.userName),
            password: sha256(this.paramForm.password),
          };
          const { name, password } = param;
          const loginPath =
            this.$api.common.userLogin + `?name=${name}&password=${password}`;
          // 加载本地系统配置
          this.$fetch(loginPath).then((response) => {
            this.loading = false;
            if (response.success) {
              let userInfo = response.returnObj;
              if (userInfo) {
                this.$log.info("用户登录成功，用户基本信息为：", userInfo);
                this.$store.dispatch("loginSuccess", userInfo);
                // this.$store.dispatch("GetOcxOptions");
                // 获取系统数据字典
              }
              this.$fetch(this.$api.common.queryAreaDevGroups, {
                type: 1,
              }).then((parkResp) => {
                if (parkResp.success) {
                  // this.initSystem();
                  let account = response.returnObj;
                  account.parkInfo = parkResp.returnObj.list[0];
                  this.$store.dispatch("loginSuccess", account);
                }
                // 系统参数获取成功，进行页面跳转
                const { account } = userInfo;
                // 获取用户系统菜单列表,无权限则进入空白页
                this.$fetch(this.$api.common.getMenusByAccount, {
                  accountNumber: account,
                }).then((res) => {
                  if (!res.success) {
                    this.$message({
                      type: "error",
                      message: res.msgContent,
                    });
                    return;
                  }
                  if (!res.returnObj.authorityList.length) {
                    // 无权限，进入空白页
                    this.$router.push({
                      path: "/pagenotfound",
                      query: {
                        msg: "暂无权限，请联系管理员！",
                      },
                    });
                    sessionStorage.setItem("isAuth", "false");
                  } else {
                    sessionStorage.setItem("MENUALL", JSON.stringify(res.returnObj));
                    sessionStorage.setItem("isAuth", "true");

                    // this.$router.push(this.target);
                    // 默认进入第一个页面
                    let firstPage = res.returnObj.menuList[0].childrens[0].childrens[0];
                    this.$router.push(firstPage.path);
                    this.addMenuFromLeftNav(firstPage)
                  }
                });
              });
            } else {
              if (response.msgCode == "200020611") {
                this.$message({
                  type: "error",
                  message: response.msgContent + ",请立刻修改密码",
                });
                // 密码过期
                this.$router.push({
                  path: "/userCode",
                  query: {
                    accountNumber: this.paramForm.userName,
                  },
                });
              } else {
                this.$message({ type: "error", message: response.msgContent });
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    addMenuFromLeftNav(tabMenu) {
      let menu = {
        activePath: tabMenu.path,
        code: tabMenu.menuCode,
        name: tabMenu.menuName,
        path: tabMenu.path,
        subsystemId: tabMenu.subsystemId,
        subsystemName: tabMenu.subsystemName
      }
      let tabList = this.$store.getters.menuTabsList || [];
      if (!this.isExist(tabList, menu)) {
        tabList.push(menu);
        if (tabList.length > 10) {
          tabList.splice(0, 1);
        }
        this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
      }
    },
    isExist(tabList, menu) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].code === menu.code || tabList[i].path === menu.path) return true;
      }
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.login-page {
  // @include set_theme_color(background-color, main-theme-color);
  background-image: url("../assets/images/login-bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  margin: 0;
  position: absolute;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;

  .canvas-background {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.2;
  }

  .login-container {
    width: 380px;
    height: 500px;
    padding: 20px;
    position: absolute;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: rgba(38, 82, 152, 0.6);
    backdrop-filter: blur(0px);

    .login-title {
      font-style: italic;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      height: 155px;
      align-items: center;

      .login-title-text {
        color: #fff;
        font-size: 28px;
        font-style: normal;
        text-align: center;
        line-height: 1;
        margin-top: 20px;
      }

      .login-logo {
        flex: 1;

        img {
          height: 80px;
          width: 230px;
        }
      }
    }

    .form-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .login-form {
        margin-top: 15px;
        width: 100%;
      }

      .user-photo {
        height: 260px;
        flex: 1;
        margin: 0 auto;
        overflow: hidden;
        text-align: center;
        background-size: contain;
      }

      .form-item {
        width: 100%;
        position: relative;
        margin-top: 10px;
        margin-bottom: 5px;

        .form-input-icon {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 40px;
          height: 40px;
          text-align: center;

          i {
            color: cornflowerblue;
            font-size: 20px;
            line-height: 40px;
          }
        }

        .form-input {
          width: 40px;
          height: 40px;
          padding: 0 20px 0 40px;
          width: 100%;
          // @include set_theme_color(background-color, top-menu-bg-color);
          -moz-box-shadow: none !important;
          -webkit-box-shadow: none !important;
          box-shadow: none !important;
          border: none;
          @include set_theme_color(border-color, top-menu-border-color);
          @include set_theme_color(color, font-default-color);

          &:hover {
            @include set_theme_color(border-color, active-border-color);
          }

          &:focus {
            @include set_theme_color(border-color, active-border-color);
          }
        }
      }
    }

    .sign-button {
      width: 100%;
      height: 45px;
      margin-top: 20px;
      font-size: 15px;
    }
  }
}
</style>
